const BLOCKS_CACHE_TTL_MS = 10 * 60 * 1000;
const PREVIEW_CACHE_TTL_MS = 30 * 1000;

const blocksCache = new Map();
const previewCache = new Map();

const buildBlocksKey = (venueId, spaceId, date, bookingMode) =>
  `${venueId}|${spaceId}|${date}|${bookingMode || 'exclusive'}`;

const buildPreviewKey = (venueId, spaceId, params = {}) =>
  JSON.stringify({
    venueId: String(venueId),
    spaceId: String(spaceId),
    date: params.date || '',
    start_time: params.start_time || params.startTime || '',
    end_time: params.end_time || params.endTime || '',
    booking_mode: params.booking_mode || params.bookingMode || 'exclusive',
    headcount: params.headcount ?? null,
    timezone: params.timezone || ''
  });

const readEntry = (map, key, ttlMs) => {
  const entry = map.get(key);
  if (!entry) return null;
  if (Date.now() - entry.fetchedAt > ttlMs) {
    map.delete(key);
    return null;
  }
  return entry.data;
};

export const getCachedAvailabilityBlocks = (venueId, spaceId, date, bookingMode) => {
  const key = buildBlocksKey(venueId, spaceId, date, bookingMode);
  return readEntry(blocksCache, key, BLOCKS_CACHE_TTL_MS);
};

export const setCachedAvailabilityBlocks = (venueId, spaceId, date, bookingMode, blocks) => {
  const key = buildBlocksKey(venueId, spaceId, date, bookingMode);
  blocksCache.set(key, { data: blocks, fetchedAt: Date.now() });
};

export const getCachedAvailabilityPreview = (venueId, spaceId, params) => {
  const key = buildPreviewKey(venueId, spaceId, params);
  return readEntry(previewCache, key, PREVIEW_CACHE_TTL_MS);
};

export const setCachedAvailabilityPreview = (venueId, spaceId, params, preview) => {
  const key = buildPreviewKey(venueId, spaceId, params);
  previewCache.set(key, { data: preview, fetchedAt: Date.now() });
};

export const clearAvailabilityCache = (venueId) => {
  if (venueId == null) {
    blocksCache.clear();
    previewCache.clear();
    return;
  }
  const prefix = `${String(venueId)}|`;
  [...blocksCache.keys()].forEach((key) => {
    if (key.startsWith(prefix)) blocksCache.delete(key);
  });
  [...previewCache.keys()].forEach((key) => {
    if (key.includes(`"venueId":"${String(venueId)}"`)) previewCache.delete(key);
  });
};
